<h1 mat-dialog-title>Requisição de entrega cadastrada como sucesso!</h1>
<div mat-dialog-content>
  <p>Delivery request Nº: {{data.id}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="1">Ok</button>
</div>
